import { connect } from "react-redux";
import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { ReactTitle } from "react-meta-tags";
import Modal from "../../../utils/customModal";
import * as instanceActions from "../../../../Redux/api";
import TableAdmissions from "../../../shared/admissions/table";
import noAproval from "../../../../../static/images/add-client-bsc.svg";
import * as ProviderActions from "../../../../Redux/actions/providerActions";
import {
  loadingHtml,
  errorContainer,
  sucessInfoModal,
  enableScroll,
} from "../../../utils/functions";
import {
  getPendingProvidersBSC,
  getTotalPendingProviders,
} from "../../../../Redux/reducer/providers";
import ProviderTemporal from "../../../shared/provider/providerTemporal";
import ActionMenuList from "canvas-core-react/lib/ActionMenuList";
import IconShow from "canvas-core-react/lib/IconShow";
import ActionMenuListItem from "canvas-core-react/lib/ActionMenuListItem";
import i18next from "i18next";
import { getFilters } from "../../../utils/utilities";

const filters = getFilters([
  {
    name: "name",
    property: "provider.institution.companyName",
    operator: "eq",
  },
  {
    name: "identification",
    property: "provider.institution.businessId",
    operator: "eq",
  },
]);

export class ProviderApprovalsComponent extends Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      sizePerPage: 10,
      contentReady: false,
      modal: {
        show: false,
        content: null,
        onClose: undefined,
        showClose: false,
      },
      list: true,
      component: false,
      providerTemporal: null,
      menus: [],
    };
  }

  componentDidMount() {
    this._isMounted = true;
    this.props.setFilters({ filters, search: this.getSearchResult });
    return this.getPendingData();
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.props.setFilters({ filters: undefined, search: undefined });
    this.props.actions.clearPendingProviders();
  }

  getSearchResult = (property, value = "") => {
    var actionFilters = [];
    const cleanValue = value.trim();

    if (cleanValue !== "") {
      // Realizamos la busqueda por filtros
      var operator = "";
      filters.map((item) => {
        if (item.property == property) {
          operator = item.operator;
        }
      });
      actionFilters = [
        { property: property, operator: operator, value: cleanValue },
      ];
    }

    this.handlerTableChange({
      page: 0,
      sizePerPage: this.state.sizePerPage,
      customFilters: actionFilters,
    });
  };

  getPendingData() {
    const { getPendingProvidersBSC } = this.props.actions;
    this.setState({ contentReady: false });

    return getPendingProvidersBSC().then(() => {
      if (this._isMounted == true) {
        this.setState({ contentReady: true });
      }
    });
  }

  closeInfo = (refress) => {
    this.setState({
      list: true,
      component: false,
    });
    if (refress) this.getPendingData();
  };

  getStatusLbl(status) {
    if (status === "TRANSITORY") {
      return (
        <span className="StatusBadge__span pending-client">
          {i18next.t("admissions.headers.suppliers.pending")}
        </span>
      );
    } else {
      return (
        <span className="StatusBadge__span pending-client">
          {i18next.t("admissions.headers.suppliers.pending_changes")}
        </span>
      );
    }
  }

  getData() {
    const { pending } = this.props;

    var resultData = [];

    if (pending.length > 0) {
      pending.map((item) => {
        const uniqueId = `${item.provider.id}-${item.provider.relation.company.id}-${item.provider.currencyAux}`;
        resultData.push({
          id: uniqueId,
          institutionName: (
            <a
              className={"admission-p record"}
              onClick={() =>
                this.setState({
                  list: false,
                  component: true,
                  providerTemporal: {
                    companyId: item.provider.relation.company.id,
                    providerId: item.provider.id,
                    currency: item.provider.currencyAux,
                  },
                })
              }
            >
              {item.companyName}
            </a>
          ),
          identification: item.businessId,
          updateBy: item.updateBy,
          relation: item.provider.relation.companyName,
          status: this.getStatusLbl(item.provider.status),
          recordComplete: item.provider.recordComplete,
          recordsTmp: item.recordsTmp,
          item,
        });
      });
    }

    return resultData;
  }

  handleMenu = (id, open) => {
    const { menus } = this.state;
    menus[`menu-${id}`] = open;
    this.setState({ menus });
  };

  getTableColumns = () => {
    const { menus } = this.state;
    return [
      {
        grow: 2,
        selector: "institutionName",
        name: `${i18next.t("admissions.headers.suppliers.company_name")}`,
      },
      {
        grow: 2,
        selector: "identification",
        name: `${i18next.t("admissions.headers.suppliers.id")}`,
      },
      {
        grow: 2,
        selector: "relation",
        name: `${i18next.t("admissions.headers.suppliers.client_name")}`,
      },
      {
        grow: 2,
        selector: "updateBy",
        name: `${i18next.t("admissions.headers.suppliers.made_by")}`,
      },
      {
        grow: 2,
        selector: "status",
        name: `${i18next.t("admissions.headers.suppliers.status")}`,
        center: true,
      },
      {
        grow: 2,
        selector: "actions",
        name: `${i18next.t("admissions.headers.suppliers.actions")}`,
        center: true,
        cellFormatter: (row) => (
          <ActionMenuList
            dialogPosition="bottom-right"
            iconType="horizontal-small"
            bottomSheet={{
              heading: "Actions",
              secondaryAction: {
                onClick: () => {},
                label: "Cancel",
              },
            }}
            isMenuOpen={menus[`menu-${row.id}`] || false}
            setIsMenuOpen={(open) => this.handleMenu(row.id, open)}
          >
            <ActionMenuListItem
              icon={() => (
                <IconShow
                  id={`providers-approval-${row.id}`}
                  className="TextButton__icon--left"
                />
              )}
              onClick={() => {
                enableScroll();
                this.setState({
                  menus: [],
                  list: false,
                  component: true,
                  providerTemporal: {
                    companyId: row.item.provider.relation.company.id,
                    providerId: row.item.provider.id,
                    currency: row.item.provider.currencyAux,
                  },
                });
              }}
            >
              {i18next.t("detail")}
            </ActionMenuListItem>
          </ActionMenuList>
        ),
      },
    ];
  };

  finishAdmission = () => {
    var buttons = {
      SelBtn: {
        text: "Continuar",
        action: this.closeModal,
      },
    };

    var content = sucessInfoModal(
      "Admisión proveedores",
      `La operación fue realizada con éxito`,
      buttons
    );

    this.setState({
      modal: { content, show: true, showClose: true, onClose: this.closeModal },
    });
  };

  commitActions = (approve, elements) => {
    const { modal } = this.state;
    const {
      instance: { instanceAction },
    } = this.props;
    modal.content = loadingHtml();
    modal.show = true;

    this.setState({ modal });
    const updateStates = Object.keys(elements).map((key) => {
      const [, providerId, companyId, currency] = key.split("-");
      return {
        companyId,
        providerId,
        approve,
        currency,
      };
    });

    return instanceAction("/providers/approve-or-rejected", "put", updateStates)
      .then((response) => {
        if (response.data.data[0].success === false) {
          modal.show = true;
          modal.content = errorContainer(
            "Error",
            response.data.data[0].message,
            {
              continueBtn: {
                text: "Continuar",
                action: this.closeModal,
              },
            }
          );
        } else if (response.data.notifications == null) {
          this.finishAdmission();
        }

        this.setState({ contentReady: false });
        return this.getPendingData();
      })
      .catch((err) => {
        if (
          err.response !== undefined &&
          Array.isArray(err.response.data.notifications)
        ) {
          const notification = err.response.data.notifications[0];
          modal.content = errorContainer(
            notification.message,
            notification.description,
            { cancelBtn: { text: "Cerrar", action: () => this.closeModal() } }
          );
        }
        modal.onClose = () => this.closeModal();

        this.setState({ contentReady: false, modal });
        return this.getPendingData();
      });
  };

  handlerTableChange = ({ page, sizePerPage, customFilters = [] }) => {
    const { getPendingProvidersBSC } = this.props.actions;

    return getPendingProvidersBSC(page, sizePerPage, customFilters).then(() => {
      this.setState({ page, sizePerPage, menus: [] });
    });
  };

  closeModal = () => {
    this.setState({
      modal: {
        show: false,
        content: null,
        onClose: undefined,
        showClose: false,
      },
    });
  };

  render() {
    const {
      contentReady,
      sizePerPage,
      page,
      modal,
      list,
      component,
      providerTemporal,
    } = this.state;
    const data = this.getData();

    return (
      <React.Fragment>
        <ReactTitle title={`Admision de Proveedores - Reverse Factoring`} />
        {contentReady ? (
          this.props.pending.length > 0 ? (
            list && (
              <React.Fragment>
                <TableAdmissions
                  headers={this.getTableColumns()}
                  data={data}
                  page={page}
                  addmissionType={`provider`}
                  sizePerPage={sizePerPage}
                  totalSize={this.props.total}
                  onTableChange={this.handlerTableChange}
                  submitAdmissions={this.commitActions}
                />
              </React.Fragment>
            )
          ) : (
            <div id="blankAprrovals">
              <img src={noAproval} className="clientImage" />
              <p>
                El sistema no posee admisiones
                <br />
                pendientes.
              </p>
              <div className="line-aproval"></div>
            </div>
          )
        ) : (
          <div className="loader innner"></div>
        )}
        {component && (
          <ProviderTemporal closeInfo={this.closeInfo} {...providerTemporal} />
        )}
        <Modal
          show={modal.show}
          handleClose={modal.onClose}
          showClose={modal.showClose}
        >
          {modal.content}
        </Modal>
      </React.Fragment>
    );
  }
}

export const mapStateToPropss = (state) => {
  return {
    pending: getPendingProvidersBSC(state),
    total: getTotalPendingProviders(state),
  };
};

export const mapDispatchs = (dispatch) => {
  return {
    actions: bindActionCreators(ProviderActions, dispatch),
    instance: bindActionCreators(instanceActions, dispatch),
  };
};

export default connect(
  mapStateToPropss,
  mapDispatchs
)(ProviderApprovalsComponent);
